import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Header, NavHeader, Page } from '../../../../../../components';
import { ROUTES } from '../../../../../../routes/routes';
import { ActionChannelList } from '../../components/action-channel-list';
import { useLavvaCreateActionContext } from '../../context';
import { TaskVariant } from '../../types';
import { BlindSettings } from './channel-forms/blind';
import { DimSettings } from './channel-forms/dim';
import { GateSettings } from './channel-forms/gate';
import { GatePartialControlModeSettings } from './channel-forms/gate-partial-control-mode';
import { GateDailyModeSettings } from './channel-forms/gate-daily-mode';
import { OnOffSettings } from './channel-forms/on-off';
import { RGBWSettings } from './channel-forms/rgbw';
import { VentilationSettings } from './channel-forms/ventilation';

const LavvaActionChannelSettings: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('action');
  const { name, channels, taskVariant } = useLavvaCreateActionContext();

  useEffect(() => {
    if (!name) navigate(ROUTES.ActionList(), { replace: true });
  }, []);

  const renderParametersView = () => {
    switch (taskVariant) {
      case TaskVariant.OnOff:
        return <OnOffSettings />;
      case TaskVariant.SetRGBW:
        return <RGBWSettings />;
      case TaskVariant.SetBlind:
        return <BlindSettings />;
      case TaskVariant.SetGate:
        return <GateSettings />;
      case TaskVariant.SetGateDailyMode:
        return <GateDailyModeSettings />;
      case TaskVariant.SetGatePartialControlMode:
        return <GatePartialControlModeSettings />;
      case TaskVariant.Dim:
        return <DimSettings />;
      case TaskVariant.SetVentilation:
        return <VentilationSettings />;
      default:
        return null;
    }
  };

  return (
    <Page
      isStickyHeader
      className="parameter-settings"
      header={
        <>
          <NavHeader />
          <Header title={t(`action.create.tasks.variants.${taskVariant}`)} />
        </>
      }
    >
      <div className="details-page">{renderParametersView()}</div>
      <ActionChannelList channels={channels} />
    </Page>
  );
};

export default LavvaActionChannelSettings;
